import { WebPlugin } from '@capacitor/core';
export class SahhaWeb extends WebPlugin {
    async configure(options) {
        console.log('configure', options);
        return { success: true };
    }
    async isAuthenticated() {
        console.log('isAuthenticated');
        return { success: true };
    }
    async authenticate(options) {
        console.log('authenticate', options);
        return { success: true };
    }
    async authenticateToken(options) {
        console.log('authenticateToken', options);
        return { success: true };
    }
    async deauthenticate() {
        console.log('deauthenticate');
        return { success: true };
    }
    async getProfileToken() {
        console.log('getProfileToken');
        return { profileToken: 'ABC123' };
    }
    async getDemographic() {
        console.log('getDemographic');
        return { demographic: `{ "gender" : "Male", "age" : 40 }` };
    }
    async postDemographic(options) {
        console.log('postDemographic', options);
        return { success: true };
    }
    async getSensorStatus(options) {
        console.log('getSensorStatus', options);
        return { status: 0 };
    }
    async enableSensors(options) {
        console.log('enableSensors', options);
        return { status: 2 };
    }
    async getScores(options) {
        console.log('getScores', options);
        console.log('startDate', options.startDateTime);
        console.log('endDate', options.endDateTime);
        return {
            value: '[{"category":"activity","unit":"count","valueType":"long","aggregation":"total","startDateTime":"2024-11-23T15:00:00+00:00","periodicity":"daily","value":"40","type":"steps","endDateTime":"2024-11-24T14:59:59+00:00"},{"category":"activity","unit":"count","valueType":"long","aggregation":"total","startDateTime":"2024-11-24T15:00:00+00:00","periodicity":"daily","value":"3662","type":"steps","endDateTime":"2024-11-25T14:59:59+00:00"},{"category":"activity","unit":"count","valueType":"long","aggregation":"total","startDateTime":"2024-11-25T15:00:00+00:00","periodicity":"daily","value":"8878","type":"steps","endDateTime":"2024-11-26T14:59:59+00:00"},{"category":"activity","unit":"count","valueType":"long","aggregation":"total","startDateTime":"2024-11-26T15:00:00+00:00","periodicity":"daily","value":"4442","type":"steps","endDateTime":"2024-11-27T14:59:59+00:00"}]',
        };
    }
    async getBiomarkers(options) {
        console.log('getBiomarkers categories', options.categories);
        console.log('getBiomarkers types', options.types);
        console.log('startDateTime', options.startDateTime);
        console.log('endDateTime', options.endDateTime);
        return {
            value: 'PLACEHOLDER',
        };
    }
    async getStats(options) {
        console.log('getStats sensor', options.sensor);
        console.log('startDateTime', options.startDateTime);
        console.log('endDateTime', options.endDateTime);
        return {
            value: 'PLACEHOLDER',
        };
    }
    async getSamples(options) {
        console.log('getSamples sensor', options.sensor);
        console.log('startDateTime', options.startDateTime);
        console.log('endDateTime', options.endDateTime);
        return {
            value: 'PLACEHOLDER',
        };
    }
    async postSensorData() {
        console.log('postSensorData');
        return;
    }
    async openAppSettings() {
        console.log('openAppSettings');
        return;
    }
}
//# sourceMappingURL=web.js.map